module.exports = __webpack_public_path__ + "4c859db5574bdcfcff5ccbe2968eb5b9.woff";